import { Component } from '@angular/core';

@Component({
  selector: 'nrk-footer',
  templateUrl: './nrk-footer.component.html',
  styleUrls: ['./nrk-footer.component.scss']
})
export class NrkFooterComponent {

}
